export default __webpack_public_path__ + "static/media/CH.55323a06.svg";